// Story 7.6 — creator_post card. The creator's own words: their mark
// claims the top-left author slot, and the printed footer says "Posted by".
// Epic 8 — rendered on parchment (ParchmentPost).

import { useState } from "react";

import { ParchmentPost, isLoadableImageUrl } from "@greenhold/components";

import { ProfileLink, relativeTime, wearSeed } from "./feedCardShared";
import type { FeedCard } from "./useFeed";

export function CreatorPostCard({ card }: { card: FeedCard }) {
  const [mediaError, setMediaError] = useState(false);

  const handle = card.creator_handle;
  // Footer preposition target keeps the @handle (or display-name fallback);
  // the author slot prefers the display name (design: "Nova" over "@nova").
  const footerName = handle
    ? `@${handle}`
    : (card.creator_display_name ?? "a creator");
  const authorLabel = card.creator_display_name ?? footerName;

  return (
    <ParchmentPost
      author={
        handle ? <ProfileLink handle={handle} label={authorLabel} /> : authorLabel
      }
      provenance="posted-by"
      provenanceName={footerName}
      time={relativeTime(card.published_at)}
      title={card.title || undefined}
      pinned={card.is_pinned}
      seed={wearSeed(card.id)}
    >
      {card.body ? (
        <p className="m-0 whitespace-pre-line">{card.body}</p>
      ) : null}
      {isLoadableImageUrl(card.media_url) && !mediaError ? (
        <img
          src={card.media_url ?? undefined}
          alt=""
          loading="lazy"
          onError={() => setMediaError(true)}
          className="mt-3 max-h-80 w-full rounded object-cover"
        />
      ) : null}
    </ParchmentPost>
  );
}
